let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2dl0L")).then(() => parcelRequire('82jOj'));